<template>
  <div class="status-bar-page flex column mt-55 pl-30 pr-30 pb-55 mb-144">
    <div class="flex between   pt-55  pb-40">
      <h2 class="bold f-21">{{ title }}</h2>
      <div @click="$router.back()" class="flex al-center pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7.857"
          height="10"
          viewBox="0 0 7.857 10"
        >
          <path
            id="Icon_material-play-arrow"
            data-name="Icon material-play-arrow"
            d="M19.857,7.5v10L12,12.5Z"
            transform="translate(-12 -7.5)"
            fill="#1a1a1a"
          />
        </svg>
        <span class="f-16 bold ml-10">{{ $fn.tr("უკან") }}</span>
      </div>
    </div>
    <div v-html="text"></div>
  </div>
</template>

<script>
export default {
  props: {
    contentData: Object
  },

  computed: {
    text() {
      return _.get(this.contentData, "data.list[0].content.tabs[0].content");
    },
    title() {
      return _.get(this.contentData, "conf.header.title");
    }
  }
};
</script>

<style lang="scss">
.status-bar-page {
  background-color: white;
  width: 962px;
  min-height: 862px;

  .pointer {
    span {
      transition: 0.2s;
    }
    @include hover {
      span {
        color: $red;
      }
    }
  }
  @media (max-width: 1550px) {
    width: 770px;
  }
  @media (max-width: 1440px) {
    width: 621px;
  }
  @media (max-width: 1439px) {
    width: 714px;
  }
  @media (max-width: 1365px) {
    width: 100%;
  }
  @media (max-width: 1023px) {
    min-height: initial;
  }
}
</style>
